import { AppState } from "store";
import { ResourcesFiltersArgs } from "./types";

export const resourcesFiltersSelector = ({
  filters,
}: AppState): ResourcesFiltersArgs => {
  return filters.resources;
};
